import { AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

interface Props {
  error?: Error
}

export default function ErrorFallback({ error }: Props) {
  return (
    <div className="container mx-auto flex min-h-[400px] items-center justify-center px-4 py-12">
      <Card className="w-full max-w-2xl">
        <CardHeader>
          <div className="flex items-center gap-2">
            <div className="bg-destructive/10 flex h-10 w-10 items-center justify-center rounded-full">
              <AlertCircle className="text-destructive h-5 w-5" />
            </div>
            <div>
              <CardTitle>An error occurred</CardTitle>
              <CardDescription>
                Something went wrong while loading this page
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        {error && (
          <CardContent className="space-y-4">
            <div className="bg-muted rounded-lg p-4">
              <p className="text-muted-foreground font-mono text-sm">
                {error.message}
              </p>
            </div>
            {error.stack && (
              <details className="text-xs">
                <summary className="mb-2 cursor-pointer font-medium">
                  Stack trace
                </summary>
                <pre className="bg-muted text-muted-foreground overflow-auto rounded-lg p-4">
                  {error.stack}
                </pre>
              </details>
            )}
            <Button onClick={() => window.location.reload()} variant="outline">
              Reload Page
            </Button>
          </CardContent>
        )}
      </Card>
    </div>
  )
}
